import { FileText } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DeepAnalysis } from '@/hooks/useDeepAnalysis';

interface DetailedAnalysisProps {
  analysis: DeepAnalysis;
}

export function DetailedAnalysis({ analysis }: DetailedAnalysisProps) {
  const paragraphs = typeof analysis.detailedAnalysis === 'string' && analysis.detailedAnalysis.trim()
    ? analysis.detailedAnalysis.split('\n\n')
    : ['Detailed narrative analysis was not returned for this review. The summary cards above contain the available market data and signals.'];
  const generatedAt = analysis.analyzedAt ? new Date(analysis.analyzedAt) : null;

  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center gap-2">
          <FileText className="w-5 h-5 text-primary" />
          <CardTitle className="text-base">Detailed Research Analysis</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="prose prose-sm max-w-none dark:prose-invert">
          {paragraphs.map((paragraph, i) => (
            <p key={i} className="text-muted-foreground leading-relaxed mb-3">
              {paragraph}
            </p>
          ))}
        </div>
        
        <div className="mt-4 pt-4 border-t border-border flex items-center justify-between text-xs text-muted-foreground">
          <span>Analysis generated by AI</span>
          <span>
            {generatedAt && !Number.isNaN(generatedAt.getTime()) ? generatedAt.toLocaleString() : 'Time unavailable'}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
